import React from "react";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import { useAtom } from "jotai";
import moment from "moment-timezone";
import { daysArrayToString } from "../../modules/RecurringBookingsUtilityFunctions";
import {
    openAvailabilityDialogAtom,
    selectedAvailabilityScIdAtom,
    selectedUserAtom,
    selectedUserProviderLocationsAtom
} from "../../atoms/usersTable";

const MobileScheduleCard = ({ schedule }) => {
    const [selectedUser] = useAtom(selectedUserAtom);
    const [selectedUserProviderLocations] = useAtom(
        selectedUserProviderLocationsAtom
    );
    const [, setSelectedAvailabilityScId] = useAtom(
        selectedAvailabilityScIdAtom
    );
    const [, setOpenAvailabilityDialog] = useAtom(openAvailabilityDialogAtom);

    const getTravelTypeText = (locations) => {
        const plLocation = locations.find((location) =>
            location.startsWith("PL-")
        );

        if (plLocation) {
            const id = plLocation.split("PL-")[1];
            const providerLocation = selectedUserProviderLocations.find(
                (loc) => loc.id === id
            );

            if (
                providerLocation &&
                providerLocation.maxtraveltype === "DRAW_TRAVEL_REGION"
            ) {
                return "Drawn";
            } else {
                return "Circular";
            }
        } else {
            return "Company locations";
        }
    };

    const ServicesRow = ({ row, providerServices }) => {
        //Parse, extract and validate schedule services with provider services
        const rowServices = JSON.parse(row.services);
        const validServices = rowServices.filter((serviceId) =>
            providerServices.some(
                (providerService) =>
                    providerService.servicetype.id === serviceId
            )
        );

        const allServicesMatch =
            validServices.length === providerServices.length;
        return (
            <Typography variant="body2">
                {allServicesMatch
                    ? "All services"
                    : `${validServices.length} of ${providerServices.length} services`}
            </Typography>
        );
    };

    const handleBookingCardClick = (schedule) => {
        if (!schedule) return;
        setSelectedAvailabilityScId(schedule.scheduleinfo);
        setOpenAvailabilityDialog(true);
    };

    return (
        <Card>
            <CardContent
                onClick={() => {
                    handleBookingCardClick(schedule);
                }}
            >
                <Typography variant="body2">
                    {schedule.SB[0].startDate === schedule.SB[0].endDate
                        ? `${moment(schedule.SB[0].startDate).format("MMM D, YYYY")}`
                        : `${moment(schedule.SB[0].startDate).format("MMM D, YYYY")} \u2014 ${moment(schedule.SB[0].endDate).format("MMM D, YYYY")}`}
                </Typography>
                <Typography variant="body2">
                    {daysArrayToString(
                        schedule.SB[0].weekDays.split("").map(Number)
                    )}
                </Typography>
                <Typography variant="body2">
                    <Stack sx={{ margin: "0px", gap: "0px" }}>
                        {schedule.SB.map((sb) => (
                            <Typography variant="body2">
                                {`${moment(sb.startTime, "HH:mm").format("h:mm A")} \u2014 ${moment(sb.endTime, "HH:mm").format("h:mm A")}\n`}
                            </Typography>
                        ))}
                    </Stack>
                </Typography>
                <Typography variant="body2">
                    {getTravelTypeText(JSON.parse(schedule.locations))}
                </Typography>
                <ServicesRow
                    row={schedule}
                    providerServices={
                        selectedUser?.provider?.servicetypes?.items || []
                    }
                />
            </CardContent>
        </Card>
    );
};

export default MobileScheduleCard;
